import { GenericSubscription } from 'components/settings/shared/subscription/subscription';

export const Subscription = () => {
  return (
    <GenericSubscription isUserPage={true} />
  );
};
